import React from "react";
import NodeOfficialTeaser from "components/Official/NodeOfficialTeaser";

export default function NodeOfficialList({ nodes }) {
  const officialsByType = [];

  nodes.forEach((node) => {
    const group = node.field_type;

    if (officialsByType[group.drupal_internal__tid] === undefined) {
      officialsByType[group.drupal_internal__tid] = {
        name: group.name,
        weight: group.weight,
        nodes: [],
      };
    }

    officialsByType[group.drupal_internal__tid].nodes.push(node);
  });

  const sortedOfficialsByType = officialsByType.sort(
    (a, b) => Number(a.weight) - Number(b.weight)
  );

  return sortedOfficialsByType.map((group) => (
    <div className="mt-12" key={group.weight}>
      <h2 className="text-3xl font-serif mb-10">{group.name}</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-8">
        {group.nodes.map((node) => (
          <div key={node.id}>
            <NodeOfficialTeaser node={node} />
          </div>
        ))}
      </div>
    </div>
  ));
}
